export const ja = {
    "TRIGGER_LISTEN": "トリガーを聴取中",
    "ASSIST_EMPTY_MSG": "AgentAssistは会話を積極的に聞いており、トリガーが発生したときに自動的にアシストする準備ができています。",
    "MYBOT_TRIGGET_LISTEN": "現在、アクティブなMy Botのタスクはありません",
    "MYBOT_EMTPY_MSG": "My Botでタスクを開始するには、検索タブに移動し、所望のタスクに対して「エージェントの入力で実行」オプションを選択してください。",
    "PROACTIVE_MODE": "プロアクティブモード",
    "SETTINGS": "設定",
    "HELP_AND_SUPPORT": "ヘルプ＆サポート",
    "HELP": "ヘルプ",
    "LANGUAGE": "言語",
    "THEME": "テーマ",
    "AUTOMATIC": "自動",
    "DARK": "ダーク",
    "AUTO_SCROLL_TOOLTIP":"アシストタブ、マイボット、およびトランスクリプトタブのコンテンツの自動スクロールを制御します",
    "LIGHT": "ライト",
    "FILE_NAME":"ファイル名",
    "ASK_A_QUESTION":"質問をする",
    "AUTOSCROLL_ASSIST":"自動スクロールアシスト",
    "THEME_DESC": "これによりシステムのデフォルトモードが使用されます",
    "DOCUMENTATION": "ドキュメンテーション",
    "DOC_DESC": "詳細なドキュメンテーション記事を確認してください。",
    "FAQ_U": "FAQ",
    "FAQ_DESC": "AgentAssistに関するよくある質問を確認してください。",
    "KORE_ACADEMY": "Koreアカデミー",
    "KORE_ACA_DESC": "アカデミーコースを通じてAgentAssistについて学びましょう。",
    "SEARCH": "検索",
    "MY_BOT": "マイボット",
    "ASSIST": "アシスト",
    "TRANSCRIPT": "トランスクリプト",
    "HISTORY": "履歴",
    "TAB_TEXT":"タブが有効になっていません！ 少なくとも1つのタブを有効にしてください",
    "STARTOVER": "最初からやり直す",
    "RESTART_INPUTS": "キャプチャされた入力で再起動",
    "ASKCUSTOMER": "顧客に尋ねる",
    "TELLCUSTOMER": "顧客に伝える",
    "WELCOME_MSG": "歓迎メッセージ",
    "TAP_SEARCH":"タップして検索",
    "SEND": "送信",
    "SENT": "送信済み",
    "AWAITING": "応答待ち | 続行するには入力してください",
    "OVERRIDE": "続行するには入力してください",
    "ACCEPT_RESPONSE": "応答が受け入れられました",
    "AGENT_ENTERED": "エージェントが入室しました",
    "EXPECTED_FORMAT": "予想されるフォーマット",
    "INPUT_VALUES": "入力値",
    "RESTART": "再起動",
    "START_OVER": "最初からやり直す",
    "RESTART_CAPTURE": "キャプチャされた入力で再起動",
    "CANCEL": "キャンセル",
    "INTERRUPT_DIALOG": "中断されたダイアログタスク",
    "RUN": "実行",
    "RUN_AGENT": "エージェントの入力で実行",
    "STEP": "ステップ",
    "DIALOG_TASK": "ダイアログタスク",
    "FAQ": "FAQ",
    "SNIPPET": "回答",
    "ARTICLE": "ウェブページ",
    "FILE": "ファイル",
    "SUGGESTED": "提案された",
    "ALL_DIALOG": "すべてのダイアログタスク",
    "DIALOG_TEXT": "ダイアログ",
    "INTENT_IDENTIFIED": "顧客の発話",
    "NOT_WHAT_LOOKING": "誤った提案？",
    "BOT": "ボット",
    "CUSTOMER": "顧客",
    "YOU": "あなた",
    "TERMINATE_CONV": "ダイアログタスクの終了",
    "TERMINATE_CONV_DESC": "ダイアログタスクを終了してもよろしいですか？ AgentAssistはこれ以上提案を行うことができません。",
    "YES_TERMINATE": "はい、終了",
    "NO_CANCEL": "いいえ、キャンセル",
    "OVERRIDE_CONTINUE": "オーバーライドモードで続行",
    "SUMMARY_TEXT": "サマリー",
    "SUBMIT": "提出",
    "INTERRUPT_OCCURED": "中断が発生しました",
    "IDENTIFIED_INTENT": "特定された意図",
    "INTERRUPT_DESC": "これを実行すると、現在進行中のダイアログタスクが終了します。",
    "ACCEPT_RUN": "受け入れて実行",
    "RUN_LATER": "後で実行",
    "KNOW_MORE": "詳細を知る",
    "MORE_TEXT": "もっと",
    "LESS_TEXT": "少なく",
    "VIEW_MORE": "さらに表示",
    "VIEW_LESS": "非表示",
    "SHOW_MORE_FAQ": "FAQをさらに表示",
    "SHOW_LESS_FAQ": "FAQを非表示",
    "SHOW_MORE_ARTICLE": "ウェブページをさらに表示",
    "SHOW_LESS_ARTICLE": "ウェブページを非表示",
    "SHOW_MORE_SNIPPET": "回答をさらに表示",
    "SHOW_LESS_SNIPPET": "回答を非表示",
    "SHOW_MORE_FILES": "さらに表示",
    "SHOW_LESS_FILES": "非表示",
    "VIEW_ALL_DIALOG": "すべてのダイアログを表示",
    "VIEW_FEW_DIALOG": "一部のダイアログを表示",
    "HELP_FULL": "役に立ちましたか？",
    "THANKYOU": "ありがとう！",
    "EXPAND_MORE": "展開 \/ もっと",
    "CLOSE_TEXT": "閉じる",
    "STARTED": "開始",
    "ENDED": "終了",
    "VIEW_FULL_ARTICLE": "ウェブページ全体を表示",
    "VIEW_FULL_FILE": "ファイル全体を表示",
    "COPIED": "コピー済み",
    "SENTI_ANALY": "感情分析",
    "WRONG_SUGGESTION": "誤った提案",
    "INCORRECT_INTENT": "不正確な意図",
    "ACCIDENTAL_CLICK": "誤ってクリック",
    "TIME_TAKING": "時間がかかります",
    "OTHER": "その他",
    "PLAYBOOK_EMPTY_MSG": "プレイブックを選択",
    "PLAYBOOK_EMPTY_DESC": "AgentAssistは利用可能なプレイブックがすべて動的であるため、プレイブックを読み込むことができません。 'プレイブックを選択'をクリックしてプレイブックにアクセスしてください",
    "STAGE": "ステージ",
    "PROCEED_TO_CLOSE": "閉じるために進む",
    "RECOMENDED_PLAYBOOK": "お勧めのプレイブック",
    "PRIMARY_SCRIPTS": "プライマリスクリプト",
    "DYNAMIC_SCRIPTS": "ダイナミックスクリプト",
    "RESUME": "再開",
    "ENABLE_CLOSE": "閉じるステージを有効にするには「閉じるに進む」ボタンをクリックしてください",
    "LIST_VIEW": "リスト表示",
    "TERMINATE": "終了",
    "MINIMIZE": "最小化",
    "PLAYBOOK": "プレイブック",
    "MAXIMIZE": "最大化",
    "NO_SEARCH_RESULT": "検索結果がありません",
    "SENTIMENT_AWAITING": "感情を待っています",
    "POSITIVE": "ポジティブ",
    "NEGATIVE": "ネガティブ",
    "COPY" : "コピー",
    "TELL_US_MORE": "もっと詳しく教えてください",
    "THANKS_FEEDBACK": "フィードバックありがとうございます",
    "SOMETHING_WRONG": "何かがうまくいきませんでした",
    "CLICK_ERROR_DETAILS": "エラーの詳細を見るにはクリックしてください",
    "NO_ACTIVE_PLAYBOOK": "アクティブなプレイブックはありません",
    "REPHRASE_QUESTION": "質問を言い換えるか、別のことを聞いてもらえますか？",
    "INTERNAL_INFO": "内部情報",
    "SOURCES": "ソース",
    "CONVERSATION_SUMMARY": "会話の概要",
    "WAITING": "待機中",
    "WIDGET_DISABLED": "ウィジェットが無効になっています",
    "AI_SETTINGS_DISABLED": "AI設定が無効になっています！AI管理者に連絡してください",
    "SERVER_CONNECTION_ERROR": "サーバーへの接続中にエラーが発生しました",
    "VIEW": "表示",
    "ATTACHMENT_INPUT": "添付ファイル入力",
    "TYPE_SUMMARY": "要約を入力してください",
    "VIEW_FULL_ARTICLE_2": "完全な記事を見る",
    "BY":"によって",
    "VIEW_FULL_FILE_2": "完全なファイルを見る",
    GENERATE_SUMMARY: "要約を生成",
    PREV_SUMMARIES: "以前に生成された要約",
    DIALOG_WORKFLOWS: "ダイアログワークフロー",
    SHOW_ALL_DIALOG: "すべてのダイアログタスクを表示",
    SHOW_ALL_DIALOGS: "すべてのダイアログを表示",
    CUSTOM_TAB: "カスタムタブ",
    AGENT_INPUT: "エージェント入力",
    "CUSTOM_EMPTY_MSG" : "現在、アクティブなワークフローはありません",
    "CUSTOM_TAB_DESC" : "ワークフローを開始するには、画面の下部にあるリストから1つを実行してください。",
    "SUBMIT_OVERALL_FEEDBACK" : "全体的なフィードバックを送信",
    "FEEDBACK_POPUP_SUBTITLE" : "ウィジェットとその機能についてのフィードバック",
    "FEEDBACK_SATISFIED" : "満足",
    "FEEDBACK_UNSATISFIED" : "不満",
    "FEEDBACK_PROVIDE_REASONS" : "もっと詳しい情報を提供…",
    "FEEDBACK_TITLE" : "フィードバック",
    "AGENTIC_THINKING" : "考え中",
    "AGENTIC_AGENT_TITLE" : "エージェント",
    "AGENTIC_COPILOT_MODE_TITLE" : "エージェンティックコパイロットモード",
    "AGENTIC_SENDING_MESSAGE" : "送信中...",
    "AGENTIC_COPILOT_DESC" : "Agentic Copilotは会話を積極的に聞いており、自動的に支援する準備ができています",
    "AGENTIC_SEARCH_RESULTS" : "エージェント結果",
    "PAUSE_AUTO_SEND" : "自動送信を一時停止",
    "PAUSE_AGENTIC" : "エージェントを一時停止",
    "RESUME_AGENTIC" : "エージェントを再開",
    "RESUME_AUTO_SEND" : "自動送信を再開"
}